export enum ResourceTypeCodes {
  //DisplayName //Code
  Produit = 'PRD',
  Industrie = 'IND',
  Acheminement = 'ACH',
  Engin = 'ENG',
  Transport = 'TRA',
  Combustible = 'CBL'
}
